import { SyncActionAPI } from '../config/actions/createActions';
import { ProductId, gemsProductIds } from './iap.ruleset';

export function hasPurchasedRecently(
  api: Pick<SyncActionAPI, 'purchases' | 'date'>,
  duration: number,
): boolean {
  const since = api.date.now() - duration;
  return api.purchases
    .getPurchaseHistory()
    .some((purchase) => purchase.purchase_time > since);
}

/**
 * Check if an id is a product id
 * @param id
 * @returns
 */
export function isProduct(id: string): id is ProductId {
  return gemsProductIds.includes(id as ProductId);
}
